import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header({ logoSrc, variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [token, setUserToken] = useState(null);

  const location = useLocation(); // Get current route

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);

    const storedToken = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (storedToken) setUserToken(storedToken);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
  alert("Logged out successfully");
  localStorage.clear();
  sessionStorage.clear();  // 👈 add this
  setUserToken(null);
  setMobileToggle(false);
  window.location.href = "/signIn";
};

  const isActive = (path) => location.pathname === path; // Check if link is active

  return (
    <>
      <header
        className={`cs_site_header cs_style1 cs_sticky_header cs_floating_header ${mobileToggle ? 'cs_mobile_toggle_active' : ''
          } ${variant} ${isSticky ? 'cs_active_sticky' : ''}`}
      >
        <div className="cs_main_header">
          <div className="container">
            <div className="cs_main_header_in flex items-center justify-between">
              <div className="cs_main_header_left flex items-center gap-5">
                <Link className="cs_site_branding" to="/">
                  <img src={logoSrc} alt="Logo" />
                </Link>
                <nav className="cs_nav">
                  <ul className={mobileToggle ? 'cs_nav_list cs_active' : 'cs_nav_list'}
                  onClick={() => setMobileToggle(false)} >
                    <li>
                      <Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link>
                    </li>
                    <li>
                      <Link to="/about" className={isActive('/about') ? 'active' : ''}>About Us</Link>
                    </li>
                    <li>
                      <Link to="/doctors" className={isActive('/doctors') ? 'active' : ''}>Doctors</Link>
                    </li>
                     <li>
                      <Link to="/blog" className={isActive('/blog') ? 'active' : ''}>Blog</Link>
                    </li> 
                    <li>
                      <Link to="/faqs" className={isActive('/faqs') ? 'active' : ''}>FAQS</Link>
                    </li> 
                    <li>
                      <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact Us</Link>
                    </li>

                    {token ? (
                      <>
                        <li style={{ marginBottom:"4px" }}>
                          <Link to="/patientprofile" className={isActive('/patientprofile') ? 'active' : ''}>Patient Profile</Link>
                        </li>
                        <li>
                          <a
                            href="#logout"
                            className="cs_logout_btn"
                            onClick={(e) => { e.preventDefault(); handleLogout(); }}
                          >
                            Logout
                          </a>
                        </li>
                      </>
                    ) : (
                   <>
                    <li>
                      <Link to="/signIn" className={isActive('/signIn') ? 'active' : ''}>
                        Sign In
                      </Link>
                    </li>
                    <li>
                      <Link to="/signup" className={isActive('/signup') ? 'active' : ''} >
                        Sign Up
                      </Link>
                    </li>
                  </> 
                    )}
                  </ul>

                  <span
                    className={mobileToggle ? 'cs_menu_toggle cs_teggle_active' : 'cs_menu_toggle'}
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
